import { render, staticRenderFns } from "./BeefCattleModal.Style#Drawer.vue?vue&type=template&id=3b1a8d7d&scoped=true"
import script from "./BeefCattleModal.Style#Drawer.vue?vue&type=script&lang=js"
export * from "./BeefCattleModal.Style#Drawer.vue?vue&type=script&lang=js"
import style0 from "./BeefCattleModal.Style#Drawer.vue?vue&type=style&index=0&id=3b1a8d7d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1a8d7d",
  null
  
)

export default component.exports